const API = process.env.REACT_APP_PUBLIC_URL;
const SECRET = process.env.REACT_APP_SECRET;
const TITLE = process.env.REACT_APP_TITLE;

export { API, SECRET, TITLE };
